document.addEventListener('DOMContentLoaded', function() {

    // Athletes Slider start
  var swiper = new Swiper(".athletes-slider", {
    autoHeight: true,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1360: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });
  // Athletes Slider End

  
  // Product Page slider start
  var galleryThumbs = new Swiper(".product-thumbnail--wrappper", {
    slidesPerView: 5,
    spaceBetween: 20,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'vertical',
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1360: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
  
  var galleryMain = new Swiper(".product-img-list", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    autoHeight: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'fade',
      fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
  // Product Page slider End

  // Product Page Qty button start
  document.querySelectorAll('.var-qty-dropdown').forEach(function(item) {
    item.addEventListener('click', function() {
        var ulElement = this.querySelector('ul');
        if (ulElement) {
            if (ulElement.style.display === 'none') {
                ulElement.style.display = 'flex';
            } else {
                ulElement.style.display = 'none';
            }
        }
    });
  });

  document.querySelectorAll('.var-qty-dropdown ul li').forEach(function(item) {
    item.addEventListener('click', function() {
        var qty = this.textContent;
        console.log(qty);
        document.querySelector('.var-qty-dropdown span').textContent = qty;
        document.querySelector('#quantity').value = qty;
    });
  });
  // Product Page Qty button End

  // Product Page Variant box start
  document.querySelectorAll('.variant-box').forEach(function(item) {
      item.addEventListener('click', function() {
          document.querySelectorAll('.variant-box').forEach(function(box) {
              box.classList.remove('active');
          });
          this.classList.add('active');
          var varID = this.getAttribute('data-variant-id');
          var varImgAlt = this.querySelector('.var-img img').getAttribute('alt');
          document.getElementById('product__variant').value = varID;
          document.querySelectorAll('.product-thumbnail--wrappper .swiper-slide').forEach(function(slide) {
              var slideImgAlt = slide.querySelector('.product-thumb-img img').getAttribute('alt');
              if (slideImgAlt === varImgAlt) {
                var dataAria = slide.getAttribute('aria-label');
                var result = dataAria.split('/')[0].trim();
                var thunbNum = Number(result) - 1;
                 galleryMain.slideTo(thunbNum,1000,false);
                  
              }
          });
      });
  });
  // Product Page Variant box End
  

  // Blog page tag filter start
  var tagName =  window.location.pathname;
  var words = tagName.split('/'); 
  var lastWord = words[words.length - 1];
  var listItems = document.querySelectorAll('.blog-filter li');
  listItems.forEach(function(listItem) {
    var tags = listItem.querySelector('a').textContent;
    var blogName = listItem.getAttribute('data-blogname');
    if (tags === lastWord) {
      listItem.classList.add('active'); 
    }
    if (blogName === lastWord) {
      listItem.classList.add('active'); 
    }
  });
  // Blog page tag filter End


  // Investors Tab Function 

  var tabAs = document.querySelectorAll('.tab');

  tabAs.forEach(function(tabA) {
      tabA.addEventListener('click', function() {
          var dataId = this.getAttribute('data-tab');
          var tabs = document.querySelectorAll('.inven-tab--wrapper');
          var tabAs = document.querySelectorAll('.tab');

          tabs.forEach(function(tab) {
              tab.classList.remove('active');
              if (tab.getAttribute('data-tab') === dataId) {
                  tab.classList.add('active');
              }
          });

          tabAs.forEach(function(tabA) {
              tabA.classList.remove('active');
          });

          this.classList.add('active');
      });
  });


  // Blog page load more start
  var article = document.querySelectorAll('.blog-articles__article');
  var lessButton = document.querySelector('#load-less');
  var moreButton = document.querySelector('#load-more');
  
  for (var i = 0; i < 3 && i < article.length; i++) {
      article[i].style.display = "block";
  }
  lessButton.style.display = "none";
  var articleElements = document.querySelectorAll('.blog-articles__article');
  var numberOfArticles = articleElements.length;
  var items = numberOfArticles;
  var shown = 12;
  function showMore() {
      lessButton.style.display = "inline-block";
      shown = document.querySelectorAll('.blog-articles__article:not([style*="display: none"])').length + 4;
      if (shown < items) {
          for (var i = 0; i < shown && i < articleElements.length; i++) {
              article[i].style.display = "block";
          }
      } else {
          for (var i = 0; i < items && i < articleElements.length; i++) {
              article[i].style.display = "block";
          }
          moreButton.style.display = "none";
      }
  }
  
  function showLess() {
      for (var i = 12; i < articleElements.length; i++) {
          article[i].style.display = "none";
      }
      moreButton.style.display = "inline-block";
      lessButton.style.display = "none";
  }
  
  moreButton.addEventListener("click", showMore);
  lessButton.addEventListener("click", showLess);
  // Blog page load more End


});

// Home Accordian start
let question = document.querySelectorAll(".home-accordian-heading");

question.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".home-accordian-heading.active");
    if(active && active !== question ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
      active.nextElementSibling.classList.remove('open-accordian');
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if(question.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.classList.add('open-accordian');
    } else {
      answer.style.maxHeight = 0;
      answer.classList.remove('open-accordian');
    }
  })
});
// Home Accordian End


// Customer Review Slider Start
var swiper = new Swiper(".customer-review-slider", {
  slidesPerView: 3,
  spaceBetween: 47,
  loop: false,
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    481: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});
// Customer Review Slider End

// Science Slider Start
var swiper = new Swiper(".acid-slider", {
  slidesPerView: 2,
  spaceBetween: 47,
  loop: false,
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,
    },
    481: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 47,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1360: {
      slidesPerView: 2,
      spaceBetween: 47,
    },
  },
});
// Science Slider End

// Footer Accordian Start
if (window.innerWidth < 992) {
    document.querySelectorAll('.footer-heading').forEach(function(item) {
        item.addEventListener('click', function() {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
                var parentMenu = this.closest('.footer-menu');
                if (parentMenu) {
                    var ulElement = parentMenu.querySelector('ul');
                    if (ulElement) {
                        ulElement.style.display = 'none';
                    }
                }
            } else {
                var activeElement = document.querySelector('.footer-heading.active');
                if (activeElement) {
                    activeElement.nextElementSibling.style.display = 'none';
                    activeElement.classList.remove("active");
                }
                this.classList.add("active");
                var parentMenu = this.closest('.footer-menu');
                if (parentMenu) {
                    var ulElement = parentMenu.querySelector('ul');
                    if (ulElement) {
                        ulElement.style.display = 'block';
                    }
                }
            }
            return false;
        });
    });
}
// Footer Accordian End

// Menu Close BTN start
document.querySelector('.menu--drawer-close').addEventListener('click', function() {
    document.querySelector('.header__icon--menu').click();
});
// Menu Close BTN End


// Customer Review Video Play Start
// document.querySelectorAll('.customer-review-slider .swiper-slide').forEach(function(slide) {
//     slide.querySelector('.play-btn').addEventListener('click', function() {
//         document.querySelectorAll('.swiper-slide video').forEach(function(video) {
//             video.pause();
//             video.closest('.swiper-slide').classList.remove("play-video");
//         });
//         this.closest('.swiper-slide').querySelector('video').play();
//         this.closest('.swiper-slide').classList.add("play-video");
//     });
// });
// Customer Review Video Play End

// // Customer Review Video Play and Pause
// document.querySelectorAll('.customer-review-slider .swiper-slide').forEach(function(slide) {
//     // Play button functionality
//     slide.querySelector('.play-btn').addEventListener('click', function() {
//         // Pause all other videos and remove "play-video" class from their slides
//         document.querySelectorAll('.swiper-slide video').forEach(function(video) {
//             video.pause();
//             video.closest('.swiper-slide').classList.remove("play-video");
//         });
//         // Play the video in the current slide and add "play-video" class
//         var video = this.closest('.swiper-slide').querySelector('video');
//         if (video) {
//             video.play();
//             this.closest('.swiper-slide').classList.add("play-video");
//         }
//     });

//     // Pause button functionality
//     var pauseButton = slide.querySelector('.pause-btn');
//     if (pauseButton) {
//         pauseButton.addEventListener('click', function() {
//             var video = this.closest('.swiper-slide').querySelector('video');
//             if (video) {
//                 video.pause();
//                 this.closest('.swiper-slide').classList.remove("play-video");
//             }
//         });
//     }

//     // Customer review image click functionality - Integrated
// var reviewImage = slide.querySelector('.customer-review-img.videoReview img');

//     if (reviewImage) {
//         reviewImage.addEventListener('click', function() {
//             var video = this.closest('.swiper-slide').querySelector('video');
//             if (video) {
//                 if (video.paused) {
//                     // Pause all other videos
//                     document.querySelectorAll('.swiper-slide video').forEach(function(video) {
//                         video.pause();
//                         video.closest('.swiper-slide').classList.remove("play-video");
//                     });
//                     // Play this video
//                     video.play();
//                     this.closest('.swiper-slide').classList.add("play-video");
//                 } else {
//                     video.pause();
//                     this.closest('.swiper-slide').classList.remove("play-video");
//                 }
//             }
//         });
//     }
// });

// Customer Review Video Play and Pause
document.querySelectorAll('.customer-review-slider .swiper-slide').forEach(function(slide) {
    // Play button functionality
    slide.querySelector('.play-btn').addEventListener('click', function() {
        // Pause all other videos and remove "play-video" class from their slides
        document.querySelectorAll('.swiper-slide video').forEach(function(video) {
            video.pause();
            video.closest('.swiper-slide').classList.remove("play-video");
        });
        // Play the video in the current slide and add "play-video" class
        var video = this.closest('.swiper-slide').querySelector('video');
        if (video) {
            video.play();
            this.closest('.swiper-slide').classList.add("play-video");

            // Add event listener for when the video ends
            video.addEventListener('ended', function() {
                video.closest('.swiper-slide').classList.remove("play-video");
            });
        }
    });

    // Pause button functionality
    var pauseButton = slide.querySelector('.pause-btn');
    if (pauseButton) {
        pauseButton.addEventListener('click', function() {
            var video = this.closest('.swiper-slide').querySelector('video');
            if (video) {
                video.pause();
                this.closest('.swiper-slide').classList.remove("play-video");
            }
        });
    }

    // Customer review image click functionality - Integrated
    var reviewImage = slide.querySelector('.customer-review-img.videoReview img');
    if (reviewImage) {
        reviewImage.addEventListener('click', function() {
            var video = this.closest('.swiper-slide').querySelector('video');
            if (video) {
                if (video.paused) {
                    // Pause all other videos
                    document.querySelectorAll('.swiper-slide video').forEach(function(video) {
                        video.pause();
                        video.closest('.swiper-slide').classList.remove("play-video");
                    });
                    // Play this video
                    video.play();
                    this.closest('.swiper-slide').classList.add("play-video");

                    // Add event listener for when the video ends
                    video.addEventListener('ended', function() {
                        video.closest('.swiper-slide').classList.remove("play-video");
                    });
                } else {
                    video.pause();
                    this.closest('.swiper-slide').classList.remove("play-video");
                }
            }
        });
    }
});

// Customer Review Video Play and Pause End




// FAQ PAGE accordian start
let faqQuestion = document.querySelectorAll(".accordian-heading");

faqQuestion.forEach(faqQuestion => {
  faqQuestion.addEventListener("click", event => {
    const active = document.querySelector(".accordian-heading.active");
    if(active && active !== faqQuestion ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
      active.nextElementSibling.classList.remove('open-accordian');
    }
    faqQuestion.classList.toggle("active");
    const answer = faqQuestion.nextElementSibling;
    if(faqQuestion.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.classList.add('open-accordian');
    } else {
      answer.style.maxHeight = 0;
      answer.classList.remove('open-accordian');
    }
  })
});
// FAQ PAGE accordian End